import React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface AuthButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  variant?: "primary" | "outline" | "google";
  children: React.ReactNode;
}

export function AuthButton({ 
  className, 
  loading, 
  variant = "primary",
  disabled,
  children, 
  ...props 
}: AuthButtonProps) {
  const baseStyles = "flex items-center justify-center gap-2 w-full h-12 rounded-lg font-medium text-base transition-all duration-200 disabled:cursor-not-allowed disabled:opacity-60";
  
  const variants = {
    primary: "text-white shadow-md hover:shadow-lg hover:scale-[1.01] active:scale-[0.99]",
    outline: "border-2 border-gray-200 bg-white text-gray-700 hover:bg-gray-50 hover:border-gray-300",
    google: "border-2 border-gray-200 bg-white text-gray-700 hover:bg-gray-50 hover:border-gray-300",
  };

  return (
    <button
      className={cn(baseStyles, variants[variant], className)}
      disabled={disabled || loading}
      style={variant === "primary" ? { 
        background: "var(--gradient-button-primary)" 
      } : undefined}
      {...props}
    >
      {loading ? (
        <>
          <Loader2 className="h-5 w-5 animate-spin" />
          <span>Chargement...</span>
        </>
      ) : (
        children
      )}
    </button>
  );
}
